(function ($) {

    $(document).ready(function () {

        if($('body').hasClass('has-installer-search')){

            var geocoder;
            var map;
            var marker;
            var top_location_result;
            $(".js-installer-form-submit").prop("disabled", true).addClass('disabled');
        
            function initialize() {
        
                //MAP
                var latlng = new google.maps.LatLng(41.659, -4.714);
        
                map = new google.maps.Map(document.getElementById("map_canvas"));
        
                //GEOCODER
                geocoder = new google.maps.Geocoder();
        
                marker = new google.maps.Marker({
                    map: map,
                    draggable: true
                });
        
            };
        
            initialize();
        
        
            $("#address").autocomplete({
        
                //This bit uses the geocoder to fetch address values
                source: function (request, response) {
                    geocoder.geocode({ 'address': request.term, 'componentRestrictions': { 'country': 'GB' } }, function (results, status) {
                        if (results.length > 0) {
                            top_location_result = results[0];
                        }
                        else {
                            top_location_result = null;
                        }
                        response($.map(results, function (item) {
                            return {
                                label: item.formatted_address,
                                value: item.formatted_address,
                                latitude: item.geometry.location.lat(),
                                longitude: item.geometry.location.lng()
                            }
                        }));
                    })
                },
        
                open: function (event, ui) {
                    $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
                },
        
                //This bit is executed upon selection of an address
                select: function (event, ui) {
                    $("#latitude").val(ui.item.latitude);
                    $("#longitude").val(ui.item.longitude);
                    $("#address").val(ui.item.value);
                    var location = new google.maps.LatLng(ui.item.latitude, ui.item.longitude);
                    marker.setPosition(location);
                    map.setCenter(location);
                    $(".js-installer-form-submit").prop("disabled", false).removeClass('disabled');
                }
            });
        
        
            $(window).keydown(function (event) {
        
                if (event.keyCode == 13) {
                    event.preventDefault();
                    $("#latitude").val(ui.item.latitude);
                    $("#longitude").val(ui.item.longitude);
        
                    validateLocationForm();
                    return false;
                }
            });
        
        
            function validateLocationForm() {
        
                if (!$("#latitude").val() || !$("#longitude").val()) {
                    console.log(top_location_result);
                    if (top_location_result) {
                        $("#latitude").val(top_location_result.geometry.location.lat());
                        $("#longitude").val(top_location_result.geometry.location.lng());
                        $("#address").val(top_location_result.formatted_address);
                        $("#c_search_box").submit();
                    }
                    else {
                        alert("Please enter a valid address.");
                        return false;
                    }
                }
                
                $("#c_search_box").submit();
            }
            
        
            $(".js-installer-form").submit(function(e) {
        
                e.preventDefault();
        
                if (top_location_result) {
                    $("#latitude").val(top_location_result.geometry.location.lat());
                    $("#longitude").val(top_location_result.geometry.location.lng());
                    $("#address").val(top_location_result.formatted_address);
                    $.LoadingOverlay("show");
                    e.preventDefault();
                    postcode = $('.js-find-installer-form__postcode').val();
                    latitude = $('#latitude').val();
                    longitude = $('#longitude').val();
                    ajaxRequest = $.ajax({
                        method: "POST",
                        url: "https://api.truframe.co.uk:1985/pricingapi/enquiry/GetNearestDGNMembers",
                        // url:"https://api.truframe.co.uk:1985/pricingapi/enquiry/GetNearestTradeCustomersIrrespectiveOfDistance", 
                        data: {
                            locationInfo: {
                                latitude: latitude,
                                longitude: longitude,
                                postcode: postcode
                            }
                        }
                    })
        
        
                    ajaxRequest.done(function (data) {
        
                        if (data.result == null) {
                            $.LoadingOverlay("hide");
                            $("#installerResultsContainer").show();
        
                            $(".installer-results-number").empty();
                            $(".installer-results-number").html("Sorry there are no installers currently in your area.");
                            $(".find-installer-results").empty();
                            $(".loader").hide();
                        }else{
                            number_installers = data.result.length;
                            $.LoadingOverlay("hide");
                            $(".find-installer-results").empty();
                            $("#installerResultsContainer").show();
                            $(".user-location").html(postcode);
                            $(".number_installers").html(number_installers);
        
                            function round(value, decimals) {
        
                                return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
                            }
        
                            $.each(data.result, function (index, obj) {
        
                                if (index === 0) {
                                    $(".find-installer-results").append("<div class='col-md-4 mb-4 mb-md-0 installer_result_" + index + "' data-order='" + index + "'></div>");
                                } else {
                                    $("<div class='col-md-4 mb-4 mb-md-0 installer_result_" + index + "' data-order='" + index + "'><div>").insertAfter(".find-installer-results > .col-md-4[data-order=" + (index - 1) + "]");
                                }
        
                                var postid = obj.postId;
                                postDataRequest = $.ajax({
                                    method: "GET",
                                    //url: "https://www.doubleglazingnetwork.com/wp-json/wp/v2/installer/" + postid + "?per_page=100"
                                    url: '/wp-admin/admin-ajax.php',
                                    data: {
                                        action: 'find_installer',
                                        guid: obj.guid
                                    }
                                });
        
                                postDataRequest.done(function (data) {
        
                                    if (data.success === false) {
                                        $('.installer_result_' + index).remove();
                                        return false;
                                    }
        
                                    $(".loader").hide();
        
                                    //console.log(data);
        
                                    placeid = data.acf.google_places_id;
        
                                    if (data.acf.address_line_3 == '') {
                                        address_line_3 = '';
                                    } else {
                                        address_line_3 = data.acf.address_line_3 + ', ';
                                    }
        
                                    if (data.acf.towncity == '') {
                                        towncity = '';
                                    } else {
                                        towncity = data.acf.towncity + ', ';
                                    }
        
                                    if (data.fimg_url == '') {
                                        img_url = 'https://www.doubleglazingnetwork.com/wp-content/themes/dgn/images/site-logo.svg';
                                    } else {
                                        img_url = data.fimg_url;
                                    }
        
                                    var element = $("<div class='installer-result-block'><a href='" + data.link + "'><div class='installer-image-holder'><img src='" + img_url + "' class='installer-image' /></div><div class='installer-result-block-text'><h2 class='heading-style-5 pt-3 mb-2'>" + data.title.rendered + "</h2><p class='installer-result-block-text__postcode mb-2'>" + data.acf.postcode + " <span>•</span> " + round(obj.drivingDistanceFromRetailCustomer, 2) + "  miles</p><p class='installer-result-block-text__address mb-2'>" + data.acf.address_line_1 + ", " + data.acf.address_line_2 + ", " + address_line_3 + "" + towncity + "" + data.acf.county + "</p><p class='rating' data-placeid=''> </p><div id='map'></div></div></a></div>");
        
                                    $(".installer_result_" + index).append(element).fadeIn();
        
                                    initRating(placeid, element);
                                    // console.log("data");
                                });
                            });
        
                            jQuery.fn.redraw = function () {
        
                                return this.hide(0, function () { $(this).show(100); });
                                // hide immediately and show with 100ms duration
                            };
        
                            $('#installerResultsContainer').redraw();
                        }
                    });
        
                    ajaxRequest.fail(function () {
        
                        alert("There is an error searching. Please try again.");
                    });
        
                }
                else {
                    alert("Please enter a valid address.");
                    return false;
                }
        
                initialize();
            });
        
        
            function initRating(placeid, element) {
                var map = new google.maps.Map(document.getElementById('map'), {
                    center: { lat: -33.866, lng: 151.196 },
                    zoom: 15
                });
        
                var infowindow = new google.maps.InfoWindow();
                var service = new google.maps.places.PlacesService(map);
        
                service.getDetails({
                    placeId: placeid
                }, function (place, status) {
                    // console.log("place callback", place, status)
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        //   console.log(place.rating);
                        // console.log(place.opening_hours.weekday_text);
                        if (place.rating === undefined) {
                        } else {
                            if(place.rating > 0){
                                // console.log(place.rating);
                                $(element).find(".rating").prepend('<p class="mini-google-revews-text">Google Rating</p>');
                                $(element).find(".rating").append(place.rating + "  ");
                                rounded_rating = Math.round(place.rating)
                                for (i = 1; i <= rounded_rating; i++) {
                                    $(element).find(".rating").append("<span class='fa fa-star checked'></span>");
                                }
                            }
                        }
        
                        var marker = new google.maps.Marker({
                            map: map,
                            position: place.geometry.location
                        });
        
                    }
                });
            }

        }

        $('.curtain-menu-button-toggle').click(function () {
            //  alert('button clicked');
            $('body').toggleClass('curtain-menu-open');
        });


        $("[data-menu-underline-from-center] a").addClass("underline-from-center");


        var loading = false;

        var scrollHandling = {
            allow: true,
            reallow: function () {
                scrollHandling.allow = true;
            },
            delay: 0 //(milliseconds) adjust to the highest acceptable value
        }


        $('.tax-filter').click(function (event) {

            $('.tax-filter').removeClass('tax-active');
            // alert("Clicked");

            // Prevent default action - opening tag page
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            // Get tag slug from title attirbute
            var selected_taxonomy = $(this).attr('title');


            // After user click on tag, fade out list of posts
            $('.tagged-posts').fadeOut();
            $('.loader').show();

            data = {
                action: 'filter_posts', // function to execute
                afp_nonce: afp_vars.afp_nonce, // wp_nonce
                taxonomy: selected_taxonomy, // selected tag
            };
            $(this).addClass('tax-active');
            $.post(afp_vars.afp_ajax_url, data, function (response) {

                if (response) {

                    $('.loader').hide();

                    // $('.tax-filter').find().attr('title');

                    //$('d[title="*"]') 

                    // Display posts on page
                    $('.tagged-posts').html(response);
                    // Restore div visibility
                    $('.tagged-posts').fadeIn();
                };
            });
        });


        $('body').on('click', '#clear-results', function() {

            $('#filterMenu #closeFilterMenu').trigger('click');

            // Get filter values
            var selected_taxonomy = new Array();
            var selected_colour = new Array();
            
            $('.filter-options.filter-by-product .filter-button.selected').each(function(){
                selected_taxonomy.push($(this).data('cat'));
            });
            $('.filter-options.filter-by-colour .filter-button.selected').each(function(){
                selected_colour.push($(this).data('colour'));
            });

            if($(this).is('#clear-all-filters, .clear-all')){
                if(selected_taxonomy){
                    selected_taxonomy = '';
                }
                if(selected_colour){
                    selected_colour = '';
                }
            }


            // After user click on tag, fade out list of posts
            $('.tagged-posts').fadeOut();
            $('.loader').show();

            data = {
                action: 'filter_insp_from_filters', // function to execute
                afp_nonce: afp_vars.afp_nonce, // wp_nonce
                taxonomy: selected_taxonomy, // selected tag
                colour: selected_colour, // selected colour
            };

            $.post(afp_vars.afp_ajax_url, data, function (response) {
                if (response) {
                    $('.loader').hide();

                    // Display posts on page
                    $('.tagged-posts').html(response);

                    $('[data-fancybox="gallery"]').fancybox({
                        arrows: true,
                        toolbar: true,
                        transitionEffect: "fade",
                        transitionDuration: 500,
                        buttons: [
                        "fullScreen",
                        "close"
                      ]
                    });
                    jQuery.fn.addBack = jQuery.fn.andSelf;

                    // Restore div visibility
                    $('.tagged-posts').fadeIn();
                };
            });

        });


        $('#insp-apply-filters, #clear-all-filters, .clear-all').click(function (event) {

            console.log('Apply filters clicked');

            $('#filterMenu #closeFilterMenu').trigger('click');

            // Get filter values
            var selected_taxonomy = new Array();
            var selected_colour = new Array();
            
            $('.filter-options.filter-by-product .filter-button.selected').each(function(){
                selected_taxonomy.push($(this).data('cat'));
            });
            $('.filter-options.filter-by-colour .filter-button.selected').each(function(){
                selected_colour.push($(this).data('colour'));
            });

            if($(this).is('#clear-all-filters, .clear-all')){
                if(selected_taxonomy){
                    selected_taxonomy = '';
                }
                if(selected_colour){
                    selected_colour = '';
                }
            }


            // After user click on tag, fade out list of posts
            $('.tagged-posts').fadeOut();
            $('.loader').show();

            data = {
                action: 'filter_insp_from_filters', // function to execute
                afp_nonce: afp_vars.afp_nonce, // wp_nonce
                taxonomy: selected_taxonomy, // selected tag
                colour: selected_colour, // selected colour
            };

            $.post(afp_vars.afp_ajax_url, data, function (response) {
                if (response) {
                    $('.loader').hide();

                    // Display posts on page
                    $('.tagged-posts').html(response);

                    $('[data-fancybox="gallery"]').fancybox({
                        arrows: true,
                        toolbar: true,
                        transitionEffect: "fade",
                        transitionDuration: 500,
                        buttons: [
                        "fullScreen",
                        "close"
                      ]
                    });
                    jQuery.fn.addBack = jQuery.fn.andSelf;

                    // Restore div visibility
                    $('.tagged-posts').fadeIn();
                };
            });
        });

    });

    $(window).load(function () {

        var MyApp = {

            // variables we need to share
            maplat: 0,
            maplng: 0,
            map: null,
            customMarker: null,

            // set the lat lgn within the namespace for testing
            setLatLng: function (lat, lng) {
                MyApp.maplat = lat;
                MyApp.maplng = lng;
            },

            // basic lookup to see if the lat lng has been created
            getLatLng: function () {
                var output = MyApp.maplat + ',' + MyApp.maplng;
                return output;
            },

            // main function to create the map
            buildMap: function (lat, lng, cm) {

                //alert("building");

                MyApp.maplat = lat;
                MyApp.maplng = lng;
                MyApp.customMarker = cm;

                // the main code to create the google map
                var latlng = new google.maps.LatLng(52.766090027506, -0.867746643902592);
                var options = {
                    zoom: 16,
                    center: latlng,
                    mapTypeId: google.maps.MapTypeId.ROAD,
                    /* snazzy maps */
                    //styles: [{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#f7f1df"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#d0e3b4"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"geometry","stylers":[{"color":"#fbd3da"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#bde6ab"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffe15f"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#efd151"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"black"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"color":"#cfb2db"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a2daf2"}]}]
                    //styles: [{"featureType":"landscape.natural","stylers":[{"color":"#bcddff"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#5fb3ff"}]},{"featureType":"road.arterial","stylers":[{"color":"#ebf4ff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#ebf4ff"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#93c8ff"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#c7e2ff"}]},{"featureType":"transit.station.airport","elementType":"geometry","stylers":[{"saturation":100},{"gamma":0.82},{"hue":"#0088ff"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#1673cb"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"saturation":58},{"hue":"#006eff"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#4797e0"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#209ee1"},{"lightness":49}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#83befc"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#3ea3ff"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"saturation":86},{"hue":"#0077ff"},{"weight":0.8}]},{"elementType":"labels.icon","stylers":[{"hue":"#0066ff"},{"weight":1.9}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"hue":"#0077ff"},{"saturation":-7},{"lightness":24}]}]
                    // styles: [{"featureType":"all","stylers":[{"saturation":0},{"hue":"#e7ecf0"}]},{"featureType":"road","stylers":[{"saturation":-70}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"water","stylers":[{"visibility":"simplified"},{"saturation":-60}]}]
                    //styles: [{"featureType":"all","stylers":[{"saturation":0},{"hue":"#e7ecf0"}]},{"featureType":"road","stylers":[{"saturation":-70}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"water","stylers":[{"visibility":"simplified"},{"saturation":-60}]}]
                };

                MyApp.map = new google.maps.Map(document.getElementById('js-contact-map'), options);

                marker = new google.maps.Marker({
                    position: latlng,
                    map: MyApp.map,
                    icon: MyApp.customMarker,
                    draggable: false
                });

            },

            //Call this to redraw the map if it's on a hidden tab intially
            refreshMap: function () {
                var currCenter = MyApp.map.getCenter();
                //console.log(currCenter);
                google.maps.event.trigger(MyApp.map, 'resize');
                MyApp.map.setCenter(currCenter);

            }

        };

        MyApp.buildMap();

    });

    $('#single-listing__product-images-other-images-toggle-button').click(function(e){
        e.preventDefault();
        if($(this).hasClass('display-secondary-images')){
            $(this).removeClass('display-secondary-images');
            $(this).html('See less');
            $('.single-listing__product-image-secondary').show();
        }else{
            $(this).addClass('display-secondary-images');
            $(this).html('See more');
            $('.single-listing__product-image-secondary').hide();
        }
    });

    $('.loader').hide();

    $('.tagged-posts').fadeIn();

})(jQuery);